import React from 'react'

export const DatatableIcon = React.forwardRef<SVGSVGElement>((props, ref): React.ReactElement => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>
      <rect x="5.44604" y="4.85094" width="13.8768" height="14.0163" rx="3" stroke="currentColor" strokeWidth="2" />
      <line x1="6.16772" y1="10.0785" x2="18.7406" y2="10.0785" stroke="currentColor" strokeWidth="2" />
      <line x1="9.95062" y1="18.8672" x2="9.95062" y2="9.79064" stroke="currentColor" strokeWidth="2" />
      <line x1="14.386" y1="18.8672" x2="14.386" y2="9.79064" stroke="currentColor" strokeWidth="2" />
    </svg>
  )
})

export default DatatableIcon
